import { PasscodesDeviceDto } from '../../../../services/passcodes/passcodes.service';

export function normalizeText(s: string): string {
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

export function filterLocks(locks: PasscodesDeviceDto[], query: string): PasscodesDeviceDto[] {
    const q = normalizeText(query.trim());
    if (!q) {
        return locks;
    }
    return locks.filter(
        (lock) => normalizeText(lock.lock_name).includes(q) || normalizeText(lock.site_name).includes(q),
    );
}
